import {
    DEALERBLOCKUNBLOCKUSER_SUCCESS,
    DEALERBLOCKUNBLOCKUSER_FAILED,
    RESET_DEALERBLOCKUNBLOCKUSER,
    LOADING_DEALERBLOCKUNBLOCKUSER,
    NETWORK_ERROR_DEALERBLOCKUNBLOCKUSER
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerBlockUnblockUser = () => {
    return { type: RESET_DEALERBLOCKUNBLOCKUSER };
};

const dealerBlockUnblockUser = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERBLOCKUNBLOCKUSER });
    await dealerServices
        .post("blockUnblockUser", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerBlockUnblockUsersuccess(res.data));
                    break;
                default:
                    dispatch(dealerBlockUnblockUserFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERBLOCKUNBLOCKUSER,
                payload: err
            });
        });
};
function dealerBlockUnblockUsersuccess(data) {
    return {
        type: DEALERBLOCKUNBLOCKUSER_SUCCESS,
        payload: data
    };
}
function dealerBlockUnblockUserFailed(data) {
    return {
        type: DEALERBLOCKUNBLOCKUSER_FAILED,
        payload: data
    };
}

export { resetDealerBlockUnblockUser, dealerBlockUnblockUser };
